<template>
  <div class="nrbar">
    <div class="nrbar-bar">
      <div
        v-for="(item, index) in values"
        :key="`nrbar-bar-key${index}`"
        class="nrbar-bar-item"
        :style="getBarStyles(item)"
        @mouseover="$emit('on-mouse-over', item.label)"
        @mouseleave="$emit('on-mouse-leave')"
      >
        <NrTooltip v-if="tooltips.length && tooltips[index]" parentTarget>
          <template v-slot:label>{{ tooltips[index] }}</template>
        </NrTooltip>
      </div>
    </div>
  </div>
</template>

<script>
import NrTooltip from '../NrTooltip/NrTooltip'

export default {
  name: 'NrBar',
  components: { NrTooltip },
  props: {
    values: {
      type: Array,
      required: true,
      default: () => [] // [{ label: string, color: string, value: number }]
    },
    tooltips: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    totalCount() {
      return this.values.reduce((sum, { value }) => {
        sum = sum + value
        return sum
      }, 0)
    }
  },
  methods: {
    getPercentage(val) {
      return (val / this.totalCount) * 100
    },
    getBarStyles(item) {
      return {
        width: `${this.getPercentage(item.value)}%`,
        backgroundColor: item.color
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/globals.scss';

.nrbar {
  &-bar {
    display: flex;
    border: 1px solid $white-ter;
    background: repeating-linear-gradient(
      -55deg,
      $grey-lighter,
      $grey-lighter 4px,
      $grey-lightest 4px,
      $grey-lightest 9px
    );
    width: 100%;
    &-item {
      height: 1.5rem;
    }
  }
}
</style>
